import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AssignLegalizationDocumentData } from '../save-info-modals/AssignLegalizationDocumentData';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AssignDocumentToLegalizationProcessesDto } from '../../models/dtos/assign-document-to-legalization-processes-dto';
import { LegalizationService } from '../../data/legalization.service';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-assign-legalization-document',
  templateUrl: './assign-legalization-document.component.html',
  styleUrls: ['./assign-legalization-document.component.scss'],
  standalone: false
})
export class AssignLegalizationDocumentComponent implements OnInit {
  dialogRef = inject<MatDialogRef<AssignLegalizationDocumentData>>(MatDialogRef);
  data = inject<AssignLegalizationDocumentData>(MAT_DIALOG_DATA);
  private legalizationService = inject(LegalizationService);


  public formGroup: FormGroup;
  private preSelectedAgreements: number[] = [];

  get legalizationsIds() {
    return this.formGroup.get('agreements') as FormControl<number[] | null>;
  }


  constructor() {
    this.formGroup = new FormGroup({
      agreements: new FormControl<number[]>([], [Validators.required])
    });
  }

  ngOnInit(): void {
    this.loadPreSelectedAgreements();
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

  onAgreementsSelectionChange(selectedIds: number[]): void {
    this.legalizationsIds.setValue(selectedIds);
  }

  onAssingDocument(): void {
    if (this.formGroup.invalid || !this.data.LegalizationDocumentId) {
      return;
    }

    let dto: AssignDocumentToLegalizationProcessesDto = {
      LegalizationDocumentId: this.data.LegalizationDocumentId,
      LegalizationsIds: (this.legalizationsIds.value ?? []).filter(id => !this.preSelectedAgreements.includes(id))
    };

    this.legalizationService.assignDocumentsToLegalizationProcesses(dto)
      .pipe(
        tap(() => {
          this.dialogRef.close(true);
        })
      )
      .subscribe();
  }

  get preSelectedAgreementsArray(): number[] {
    return this.preSelectedAgreements;
  }

  isAssignButtonEnabled(): boolean {
    const legalizationsIdsValue = this.legalizationsIds.value;
    return !!((legalizationsIdsValue?.length ?? 0) > 0 && legalizationsIdsValue && legalizationsIdsValue.length > this.preSelectedAgreements.length);
  }

  private loadPreSelectedAgreements(): void {
    if (this.data.LegalizationDocumentId) {
      this.legalizationService.getAssignedLegalizationProcesses(this.data.LegalizationDocumentId)
        .pipe(
          tap((response) => {
            if (response && response.LegalizationsIds.length > 0) {
              this.preSelectedAgreements = response.LegalizationsIds;
              this.legalizationsIds.setValue(this.preSelectedAgreements);
            }
          })
        )
        .subscribe();
    }
  }
}
